
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ClassificationType } from '../../../models/classification.model';
import { ClassificationService } from '../../../services/classification/classification.service';

@Component({
  selector: 'app-kv-classification-types-form',
  template: `
    <form [formGroup]="addEditFormTypes" (ngSubmit)="saveOrUpdate()" RestrictFocus>
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row bottom-10-margin">
          <div class="ui-grid-col-4"><label>{{ 'common.certification_name' | translate}}</label></div>
          <div class="ui-grid-col-8"><input formControlName="name" pInputText/></div>
        </div>
      </div>
      <p-footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
                  [disabled]="!addEditFormTypes.valid || !addEditFormTypes.dirty"
                  [label]="'common.add_classification' | translate"></button>
        </div>
      </p-footer>
    </form>
  `
})
export class ClassificationTypesForm2Component implements OnChanges {

  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() editingElement: ClassificationType;
  addEditFormTypes: FormGroup;

  constructor(
    private fb: FormBuilder,
    private svcClassification: ClassificationService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.addEditFormTypes = this.fb.group({
      'name': new FormControl(this.editingElement.name, Validators.compose([Validators.required, Validators.maxLength(100)]))
    });
  }

  saveOrUpdate(): void {
    let newData = Object.assign({}, this.editingElement, this.addEditFormTypes.value);
    this.onAddElement.emit(newData);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-types-form.component.ts